export default function ViewerBanner({ user }) {
  if (!user?.workspace_id || user.workspace_role !== "viewer") return null;
  return <div role="status" aria-live="polite" data-testid="viewer-banner" className="mb-6 rounded-lg border border-amber-500/25 bg-amber-500/10 px-4 py-3 text-sm">Vous êtes <strong>Viewer</strong> dans ce workspace — accès en lecture seule.</div>;
}
